import styled, { css } from 'styled-components';
import { Layout } from 'antd';

const { Header } = Layout;

export const HeaderContainer = styled(Header)<{ isPageHome: boolean }>`
  padding: 0 2% !important;
  background: ${({ theme }) => theme.colors.background} !important;
  width: 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 1;

  ${({ isPageHome, theme }) =>
    !isPageHome &&
    css`
      box-shadow: ${theme.shapes.boxShadow};
      border-bottom: 1px solid ${theme.colors.border};
    `}

  .header-menu-logo {
    display: flex;
    align-items: center;
    height: 100%;
  }
`;

export const MenuContent = styled.div`
  display: flex;
  flex-direction: column;

  .header-language-selector {
    margin: 10px 0;
  }

  .header-switch-theme {
    margin-top: 8px;
    margin-bottom: 4px;
  }

  .ant-divider {
    margin: 10px 0;
  }

  .settings-menu-languages {
    padding: 8px 4px;
    border-radius: ${({ theme }) => theme.shapes.borderRadius};
    background: ${({ theme }) => theme.colors.background1};
  }

  .ant-radio-group {
    display: flex;
    flex-wrap: nowrap;
    width: 100%;

    span {
      font-size: ${({ theme }) => theme.fontSizes.small};
    }
  }
`;

export const NotificationContent = styled.div`
  max-height: 500px;
  overflow-y: auto;
  min-width: 350px;

  &.has-scrollbar {
    padding-right: 8px;
  }

  .virtual-list-item span {
    background: none !important;
  }

  .virtual-list-item:hover div[class*='NotificationContainer'] {
    box-shadow: 0 1px 2px -2px rgba(0, 0, 0, 0.16),
      0 3px 6px 0 rgba(0, 0, 0, 0.12), 0 5px 12px 4px rgba(0, 0, 0, 0.09);
  }

  .ant-card-hoverable:hover {
    border-color: ${({ theme }) => theme.colors.border};
    transition: box-shadow 0.3s ease, border-color 0.3s ease !important;
    box-shadow: 0 1px 2px -2px rgba(0, 0, 0, 0.16),
      0 3px 6px 0 rgba(0, 0, 0, 0.12), 0 5px 12px 4px rgba(0, 0, 0, 0.09);
  }

  .ant-card-head {
    padding: 0 12px;
    border-bottom: 1px solid ${({ theme }) => theme.colors.border};
  }

  .ant-card-head-title {
    color: ${({ theme }) => theme.colors.text};
  }

  .ant-badge {
    padding: 2px 8px;
    border-radius: 8px;
    line-height: 1.5715;
    font-size: 14px;
  }

  .ant-badge.critical {
    color: #d2211d;
    border: 1px solid #d2211d;
  }

  .ant-badge.ok {
    color: #00be14;
    border: 1px solid #00be14;
  }

  .ant-card-body {
    padding: 12px;
  }

  .anticon-fall,
  .anticon-rise,
  .anticon-bell,
  .anticon-alert {
    color: ${({ theme }) =>
      theme.title === 'light' ? theme.colors.black : theme.colors.white};
  }

  .notification-card-extra {
    display: flex;
    gap: 8px;
    align-items: center;
  }

  .notification-inner-content {
    display: flex;
    flex-flow: column;
    gap: 8px;
  }

  .alarm-notification-item {
    display: flex;
    flex-flow: row;
    justify-content: space-between;
    align-items: center;
  }

  .alarm-notification-item-icon {
    display: flex;
    flex-flow: row;
    align-items: center;
    gap: 8px;
  }

  .notification-card-divider {
    margin: 12px 0;
    background: 1px solid ${({ theme }) => theme.colors.border};
  }

  .notification-card-label {
    margin-bottom: 0px;
    color: ${({ theme }) => theme.colors.text};
    font-size: 14px;
  }

  .notification-card-value {
    margin-bottom: 0px;
    color: ${({ theme }) => theme.colors.text};
    font-weight: 500;
    font-size: 16px;
  }

  .notification-card-date-time {
    margin-bottom: 0px;
    color: ${({ theme }) => theme.colors.text1};
  }
`;

export const AlarmNotificationContentContainer = styled.div`
  display: flex;
  flex-flow: column;
  gap: 1rem;
`;
